
import { Component, Mixins } from "vue-property-decorator";
import { IDrawableItem, ILineDrawable, instanceOfILineDrawable } from "../../../../../domain/document/items";
import { LineStyle } from "../../../../../domain/drawing";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";

@Component({
})
export default class LineDrawerPropertyEditableMixin extends Mixins() implements IDrawableItemEditable {
  editingSource: IDrawableItem;
  writeProperty: (write: (source: ILineDrawable) => void) => void;

  get lineStyle(): LineStyle {
    return instanceOfILineDrawable(this.editingSource)
      ? this.editingSource.lineStyle
      : undefined;
  }

  set lineStyle(value: LineStyle) {
    this.writeProperty(s => s.lineStyle = value);
  }
}
